import { h, Component } from 'preact'
import { withStore } from '../../providers/store'
import { iStore } from '../../types/store'
import { iChat } from '../../types/chat'
import { Loader } from '../../UI/Loader'
import ChatHeader from '../ChatHeader'
import { getStatus } from '../../utils/status'
import s from './Chat.css'
import Editor from '../Editor'
import Dialog from '../Dialog'

interface iProps {
  chatId: number
  store: iStore
}

class Chat extends Component<iProps> {
  render () {
    const { chatId, store } = this.props
    const data = store.chats[chatId] as iChat

    if (!data) {
      return (
        <div className={s.Chat__loader}>
          <Loader
            size="l"
            color="blue"
          />
        </div>
      )
    }

    const isOnline = getStatus(
      store.statuses[chatId],
      store.users![chatId]
    )

    return (
      <div className={s.Chat}>
        <ChatHeader
          data={data}
          group={store.groups[chatId]}
          isOnline={isOnline}
        />

        <div className={s.Chat__content}>
          {store.lastMessages[chatId] && (
            <Dialog
              chatId={chatId}
              lastMessage={store.lastMessages[chatId]}
            />
          )}

          <div className={s.Chat__footer}>
            <Editor/>
          </div>
        </div>
      </div>
    )
  }
}

export default withStore(Chat)
